import { render } from "./app-tooltip.vue?vue&type=template&id=4a5456c3"
import script from "./app-tooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./app-tooltip.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/app-tooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a5456c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a5456c3', __exports__)) {
    console.log('reload')
    api.reload('4a5456c3', __exports__)
  }
  
  module.hot.accept("./app-tooltip.vue?vue&type=template&id=4a5456c3", () => {
    console.log('re-render')
    api.rerender('4a5456c3', render)
  })

}


export default __exports__